import React, { useMemo, useState } from "react";
import { Button, Select, Space, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useAuth0 } from "../../../react-auth0-spa";
import { useAppContext } from "../../../context";
import config from "../../../api_config.json";
import updateOrgDetails from "./updateOrgDetails";
import isFuture from "date-fns/isFuture";
import parseISO from "date-fns/parseISO";

const FieldIstanza = ({ org }) => {
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();

  const isGiotto =
    org.tipo_licenza === "giotto" &&
    typeof org.data_scadenza_giotto !== "undefined";

  const expiryDate = isGiotto
    ? org.data_scadenza_giotto?.iso
    : org.data_scadenza?.iso;

  const isCurrentlyInDemo = isFuture(parseISO(expiryDate));

  const optionsIstanze = (
    <>
      <Select.Option value="demo" label="DEMO">
        <Tag color={isCurrentlyInDemo ? "green" : "volcano"} style={{ margin: 0 }}>
          DEMO
        </Tag>
      </Select.Option>
      <Select.Option value="free" label="FREE">
        <Tag color="blue" style={{ margin: 0 }}>FREE</Tag>
      </Select.Option>
      <Select.Option value="production" label="PRODUCTION">
        <Tag color="green" style={{ margin: 0 }}>PRODUCTION</Tag>
      </Select.Option>
    </>
  );

  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(org.tipo_istanza);

  const renderTag = useMemo(() => {
    const v = value || org.tipo_istanza;
    if (v === "demo") {
      return (
        <Tag color={isCurrentlyInDemo ? "green" : "volcano"} style={{ margin: 0 }}>
          DEMO
        </Tag>
      );
    }
    if (v === "production") {
      return (
        <Tag color="green" style={{ margin: 0 }}>
          PRODUCTION
        </Tag>
      );
    }
    if (v === "free") {
      return (
        <Tag color="blue" style={{ margin: 0 }}>
          FREE
        </Tag>
      );
    }
    return <Tag style={{ margin: 0 }}>-</Tag>;
  }, [value, org.tipo_istanza, isCurrentlyInDemo]);

  if (!editing) {
    return (
      <Space size="small">
        {renderTag}
        <Button
          size="small"
          type="link"
          icon={<EditOutlined />}
          onClick={() => setEditing(true)}
        >
          Modifica
        </Button>
      </Space>
    );
  }

  return (
    <Space size="small">
      <Select
        size="small"
        style={{ minWidth: 160 }}
        optionLabelProp="label"
        value={value}
        onChange={(val) => {
          setValue(val);
          const fields = [
            { key: "tipo_istanza", value: val },
          ];
          updateOrgDetails(
            getTokenSilently,
            config,
            isProd,
            org.objectId,
            fields
          );
          setEditing(false);
        }}
        onBlur={() => setEditing(false)}
      >
        {optionsIstanze}
      </Select>
      <Button size="small" onClick={() => setEditing(false)}>Annulla</Button>
    </Space>
  );
};

export default FieldIstanza; 
